import { Flash } from 'app'

export class Logger {
    static log = (type, message, data = {}) => {
        var symb, col
        switch (type) {
            case 'INFO':
                [symb, col] = ['!!', 'cyan']
                break
            case 'SEND':
                [symb, col] = ['>>', 'blue']
                break
            case 'RECV':
                [symb, col] = ['<<', 'green']
                break
            case 'APIERR':
                [symb, col] = ['#<', 'orange']
                break
            case 'ERROR':
                [symb, col] = ['##', 'red']
                break
            default:
                [symb, col] = ['--', 'initial']
        }
        console.groupCollapsed(`${symb} %c ${message}`, `color:${col}`)
        console.dir(data)
        console.groupEnd()
    }
}
export class AppError extends Error {
    constructor(message, info = {}, type = 'ERROR') {
        super(message)
        Logger.log(type, message, info)
    }
}
export const copyUrlToClipboard = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
        Flash.add({ type: 'SUCCESS', message: 'Page URL copied to clipboard' })
    }).catch(err => { });
}